import { render } from "./ListadoProductos.vue?vue&type=template&id=bcecbaf6&scoped=true"
import script from "./ListadoProductos.vue?vue&type=script&lang=js"
export * from "./ListadoProductos.vue?vue&type=script&lang=js"

import "./ListadoProductos.vue?vue&type=style&index=0&id=bcecbaf6&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcecbaf6"]])

export default __exports__